import { isClientError } from '@utils/graphqlUtils';
import { z } from 'zod/v4';

export enum UnapplicableFilterType {
  Abac = 'Abac',
  Global = 'Global',
}

export const unapplicableFilterExtension = z.object({
  filter_type: z.enum(UnapplicableFilterType),
  unreachable_fields: z.string().optional().nullable(),
  root_projection: z.string().optional().nullable(),
});

export type UnapplicableFilterDetails = z.infer<typeof unapplicableFilterExtension>;

export interface GqlErrorLike {
  extensions?: {
    unapplicableFilter?: unknown;
  };
}

export const UNAPPLICABLE_FILTER_TITLE = 'No Data Found';

export const UNAPPLICABLE_FILTER_MESSAGES: Record<UnapplicableFilterType, string> = {
  [UnapplicableFilterType.Global]: 'Unable to resolve the filter applied',
  [UnapplicableFilterType.Abac]: "This widget's data is hidden because a content permission filter doesn't apply to its entity type.",
};

const flattenToGqlErrors = (errors: unknown[]): GqlErrorLike[] =>
  errors.flatMap<GqlErrorLike>(error => (isClientError(error) ? error.response?.errors || [] : [error as GqlErrorLike]));

export const getUnapplicableFilterError = (errors: unknown[] | undefined | null): UnapplicableFilterDetails | undefined => {
  const parsedResults = flattenToGqlErrors(errors || []).map(error =>
    unapplicableFilterExtension.safeParse(error?.extensions?.unapplicableFilter)
  );
  return parsedResults.find(parsed => parsed.success)?.data;
};
